import { useEffect, useMemo } from 'react'

/*****************************************************
 Derives a local preview URL for a picked File and
 releases it when the file changes or on unmount
 *****************************************************/

const useObjectUrl = (file?: File|null): string|undefined => {

    const url = useMemo(() => file ? URL.createObjectURL(file) : undefined, [file])

    useEffect(() => {
        return () => {
            if (url) URL.revokeObjectURL(url)
        }
    }, [url])

    return url
}

export { useObjectUrl }
